export default __webpack_public_path__ + "static/media/slider5.2f2c71e7.jpg";